import {createPostHook} from "services/http/hooks";
import {User} from "./types";

// Static POST: Login
export const useLogInMutation = createPostHook<
  User,
  {phone: string; password: string}
>("/auth/login");

// Static POST: Logout
export const useLogOutMutation = createPostHook("/auth/logout");


// Static POST: Refresh token
export const useRefreshTokenMutation = createPostHook<User>("/auth/refresh");
